import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  _dateFormatter,
  _timeFormatter,
  addQueryParamToUrl,
  getQueryParamValue,
  getUserName,
} from '../../../helpers/utils';
import { showModal } from '../../../redux/error/ErrorAction';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { POST } from '../../../services/rest.service';
import Pagination from '../../../components/global/Pagination';
import { usePagination } from '../../../helpers/customHooks';
import SelectBox from '../../../components/UI/SelectBox';
import SearchBar from '../../../components/global/SearchBar';

export const user_types = {
  application_client: 'Individual Importer',
  application_corporate_client: 'Corporate Importer',
  forwarding_agent: 'Transporter',
  clearing_agent: 'Clearing Agent',
};

const tableHeaders = [
  { width: '', name: 'ID', value: 'action', class: '' },
  { width: '', name: 'Name', value: 'action', class: '' },
  { width: '', name: 'Email', value: 'action', class: '' },
  { width: '', name: 'Mobile', value: 'action', class: '' },
  { width: '', name: 'Address', value: 'action', class: '' },
  { width: '', name: 'Created At', value: 'action', class: '' },
  { width: '', name: 'Action', value: 'action', class: '' },
];

const ApprovedUsers = (props) => {
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);
  const [userType, setUserType] = useState(() => {
    const ut = getQueryParamValue(props.location, 'utype');
    return ut || 'application_client';
  });
  const [searchText, setSearchText] = useState(
    getQueryParamValue(props.location, 'searchText') || '',
  );

  const {
    selectedPage,
    setSelectedPage,
    itemsPerPage,
    totalPages,
    setTotalPages,
    handleSelected,
    handlePageCountChange,
  } = usePagination(
    getQueryParamValue(props.location, 'page'),
    getQueryParamValue(props.location, 'perPage'),
    props.history,
  );

  const getUsers = (page, limit, uType, st) => {
    dispatch(showLoading());
    const payload = {
      user_type: uType || '',
      page: page,
      per_page: limit,
      identity_verified: 1,
    };

    if (st) payload.search = st;

    POST(`/users/getUsers`, payload)
      .then(({ data }) => {
        setRecords(data.users);
        setTotalPages(data.total_count / itemsPerPage);
        dispatch(hideLoading());
      })
      .catch((err) => {
        dispatch(hideLoading());
        dispatch(showModal(err.message));
      });
  };
  useEffect(() => {
    getUsers(selectedPage, itemsPerPage, userType, searchText);
  }, [selectedPage, itemsPerPage, userType, searchText]);

  const handleUserTypeChange = (e) => {
    const val = e.target.value;
    setUserType(val);
    addQueryParamToUrl(props.history, 'utype', val);
  };

  const handleSearch = (text) => {
    const value = text || '';
    addQueryParamToUrl(props.history, 'searchText', value);
    setSearchText(value);
  };

  const handleSearchClear = () => {
    if (searchText) {
      setSearchText('');
      setRecords([]);
      setSelectedPage(1);
      setTotalPages(0);
      addQueryParamToUrl(props.history, 'searchText', '');
    }
  };

  return (
    <div id="tabblock4" className="tabcontent">
      <div className="bodycont">
        <div className="">
          <div className="approved-users-heading">
            <h1 className="page-heading mb-0">Approved</h1>
            <SelectBox
              id="reg_year"
              name="reg_year"
              className="select-controls"
              value={userType}
              options={user_types}
              onChange={handleUserTypeChange}
            />
            <SearchBar
              id="search"
              onSearch={handleSearch}
              onClearSearchText={handleSearchClear}
              value={searchText}
              placeholder="Search User"
            />
          </div>
          <div className="tab-pane active" id="resp-tab7">
            <div className="table-responsive clearingtable">
              <div className="table-responsive">
                <table className="table">
                  <thead className="thead">
                    <tr>
                      {tableHeaders.map((x, index) => {
                        return (
                          <th className={x.class} width={x.width} key={index}>
                            {x.name}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  {records.length > 0 && (
                    <tbody>
                      {records.map((x, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{x.user_id || 'N/A'}</strong>
                          </td>
                          <td>{getUserName(x)}</td>
                          <td>{x.email}</td>
                          <td>{x.mobile_number}</td>
                          <td>{x.address || x.company_address}</td>
                          <td>
                            <p className="mb-1">{_dateFormatter(x.created_at)}</p>
                            <p className="mb-1">{_timeFormatter(x.created_at)}</p>
                          </td>
                          <td>
                            <a
                              onClick={() => {
                                props.history.push({
                                  pathname: `/lawyer/user/details/${x.uuid}`,
                                  state: { agentName: x.company_name },
                                });
                              }}
                              className="review mx-1"
                            >
                              View Details
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
                {records.length <= 0 && <h3 className={'empty-message'}>Records Not Found</h3>}
                {records.length > 0 && (
                  <Pagination
                    pageCount={totalPages}
                    onPageChange={handleSelected}
                    selectedPage={selectedPage}
                    setItemsPerPage={handlePageCountChange}
                    itemsPerPage={itemsPerPage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovedUsers;
